import React from "react";
import Markdown from "react-markdown";

const CommonTextBelowBanner = ({ data, size }) => {
  if (!data) {
    return null;
  }
  return (
    <div className="container text-center lg:pt-[1vw] pt-[1.5vw] lg:px-[1vw] px-[2vw] text-primary">
      {data?.description?.data?.description && (
        <div>
          {data?.description?.data?.description
            ?.split("\n")
            .map((line, index) => (
              <div
                key={index}
                className={`${
                  size
                    ? "lg:text-[1.4vw] md:text-[3.8vw] text-[4.5vw] font-redhatMedium"
                    : "lg:text-[1.25vw] md:text-[3.6vw] text-[4vw] font-redhatRegular"
                } leading-tight`}
              >
                <Markdown>{line}</Markdown>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default CommonTextBelowBanner;
